export interface Params {
  label?: string;
  fields?: string;
}

export type QueryFn = (params?: Params) => string;

export const fields = (strings: TemplateStringsArray, ...vars: string[]) => {
  return `${vars.map((value, index) => {
    return `${strings[index]}${value}`;
  })}${strings[strings.length - 1]}`;
};

export const query = (
  label: string,
  fieldName: string,
  inputType: string,
  fields: string,
) => `
query ${label}($input: ${inputType}) {
  ${fieldName}(input: $input) {
    ${fields}
  }
}`;

export const mutation = (
  label: string,
  fieldName: string,
  inputType: string,
  fields: string,
) => `
mutation ${label}($input: ${inputType}) {
  ${fieldName}(input: $input) {
    ${fields}
  }
}`;
